export default __webpack_public_path__ + "static/media/valdisere-2x.acbfd19d.webp";